<template>
  <q-form ref="formRef" class="q-mt-md" greedy>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>背景色</div>
        <div class="text-caption">backgroundColor</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.backgroundColor"
        :rules="[(val) => colorValidate(val) || 'invalid property']"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.backgroundColor" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>罫線</div>
        <div class="text-caption">separator</div>
      </div>
      <q-select outlined dense emit-value map-options v-model="value.separator" :options="separatorList" class="col" />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>罫線色</div>
        <div class="text-caption">separatorColor</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.separatorColor"
        :rules="[(val) => colorValidate(val) || 'invalid property']"
        placeholder="#FFFFFF"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.separatorColor" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
  </q-form>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageBlockStyle } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class BlockStyle extends Vue {
  @Prop()
  modelValue!: IFlexMessageBlockStyle

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBlockStyle) {
    this.$emit('update:modelValue', value)
  }

  get separatorList() {
    return [
      {
        label: '',
        value: '',
      },
      {
        label: 'True',
        value: true,
      },
      {
        label: 'False',
        value: false,
      },
    ]
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    this.validate()
  }
}
</script>

<style scoped lang="scss">
</style>
